import { render, staticRenderFns } from "./ModalPrompt.vue?vue&type=template&id=6b23d1ba&scoped=true"
import script from "./ModalPrompt.vue?vue&type=script&lang=js"
export * from "./ModalPrompt.vue?vue&type=script&lang=js"
import style0 from "./ModalPrompt.vue?vue&type=style&index=0&id=6b23d1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23d1ba",
  null
  
)

export default component.exports